/**
 * Is Stringed Number
 */
const isStringedNumber = (text: string) => !isNaN(+text);

export { isStringedNumber };
